import { P2TextLabel } from 'react-bootstrap-common-script';
import { Separator } from '../../../components/separator';
import { useAppSelector } from '../../../redux/hook';
import useViewportWidth from '../../../components/stepper/useViewportWidth';
import { useGetApplicationHdbRefQuery } from '../../../redux/services/getStageE';

type OverviewSegmentProps = {
  loginUserUinfin: string;
  applicationId: string;
  singpassToken: string;
};

function OverViewSegment({ loginUserUinfin, applicationId, singpassToken }: OverviewSegmentProps) {
  const isDesktopView = useViewportWidth();
  const startApplicationFormData = useAppSelector((state) => state.app.ApplicationStartSlice.formData);
  const applicationStep1FormData = useAppSelector((state) => state.app.ApplicationStep1Slice.formData);

  const { data: applicationHdbRefData } = useGetApplicationHdbRefQuery(
    {
      application_id: applicationId,
      uinfin: loginUserUinfin,
      singpass_token: singpassToken,
    },
    { skip: applicationId === '0' || applicationId === null }
  );

  return (
    <>
      <div className='address-container'>
        <div className='address-box'>
          <div className='title'>
            <P2TextLabel label={'Flat Address'} lineHeight={'24px'} />
          </div>
          <div className='content'>
            <p>{startApplicationFormData.selected_hdb_property?.address}</p>
          </div>
        </div>
        <div className='address-box'>
          <div className='title'>
            <P2TextLabel label={'HDB Reference No.'} lineHeight={'24px'} />
          </div>
          <div className='content'>
            <p>{applicationHdbRefData?.proposed_hdb_ref}</p>
          </div>
        </div>
      </div>
      {isDesktopView && (
        <div className='owner-info'>
          <div className='owner-info-title'>
            <div className=' flex-grow-1'>
              <P2TextLabel label={'Current Owner(s)/  Executor(s)/ Administrator(s)/ Trustee(s)'} lineHeight={'24px'} />
            </div>
            <div className=' flex-grow-1'>
              <P2TextLabel label={'Proposed Owner(s)'} lineHeight={'24px'} />
            </div>
          </div>
          <Separator />
          <div className='d-flex'>
            <div className='owner-info-content  flex-grow-1'>
              {applicationStep1FormData.household.owners.map((owner, index: number) => (
                <p key={index}>{owner.myinfo.name}</p>
              ))}
            </div>
            <div className='owner-info-content  flex-grow-1'>
              {applicationStep1FormData.household.incoming_owners.map((incomingOwner, index: number) => (
                <p key={index}>{incomingOwner.myinfo.name}</p>
              ))}
            </div>
          </div>
        </div>
      )}

      {!isDesktopView && (
        <div className='d-flex flex-column gap-2'>
          <div className='owner-info'>
            <div className='owner-info-title'>
              <div>
                <P2TextLabel label={'Current Owner(s)/  Executor(s)/ Administrator(s)/Trustee(s)'} fontSize={18} lineHeight={'24px'} />
              </div>
            </div>
            <Separator />
            <div className='d-flex'>
              <div className='owner-info-content'>
                {applicationStep1FormData.household.owners.map((owner, index: number) => (
                  <p key={index}>{owner.myinfo.name}</p>
                ))}
              </div>
            </div>
          </div>
          <div className='owner-info'>
            <div className='owner-info-title'>
              <div>
                <P2TextLabel label={'Proposed Owner(s)'} fontSize={18} lineHeight={'24px'} />
              </div>
            </div>
            <Separator />
            <div className='d-flex'>
              <div className='owner-info-content'>
                {applicationStep1FormData.household.incoming_owners.map((incomingOwner, index: number) => (
                  <p key={index}>{incomingOwner.myinfo.name}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default OverViewSegment;
